module.exports = __webpack_public_path__ + "static/media/splash_acima.53ca1e84.png";